export const openLink = (url) => {
  if (window.Telegram && window.Telegram.WebApp) {
    window.Telegram.WebApp.openLink(url);
  } else {
    window.open(url, '_blank');
  }
};

// ponytail: t.me links need openTelegramLink (switches to a TG chat),
// not openLink (opens external browser). Fallback for non-WebApp dev.
export const openTelegramLink = (url) => {
  const tg = window.Telegram?.WebApp;
  if (tg?.openTelegramLink) tg.openTelegramLink(url);
  else window.open(url, '_blank');
};
